import { html, LitElement, css } from "lit";
import { customElement, property } from "lit/decorators.js";

@customElement('color-picker-button')
export class ColorPickerButton extends LitElement {
  static styles = css `
    :host {
      display: inline-flex !important;
      align-items: center;
      gap: 4px;
      visibility: visible !important;
    }
    .toolbar-margin-label {
      font-size: 12px;
      color: rgba(0, 0, 0, 0.6);
      font-family: Roboto, sans-serif;
      visibility: visible !important;
    }
    .color-swatch {
      display: inline-flex !important;
      visibility: visible !important;
      height: 28px;
      min-width: 28px;
      min-height: 28px;
      border: 2px solid rgba(0, 0, 0, 0.2);
      border-radius: 4px;
      cursor: pointer;
      box-sizing: border-box;
      padding: 2px;
    }
    .color-swatch:hover {
      border-color: #6750a4;
    }
    .color-swatch::part(icon) {
      display: none;
    }
    div.pickr {
      display: none
    }
  `;

  @property({ type: String }) backgroundColor = '#000000';
  @property({ type: String }) colorType = 'text';
  @property({ type: String }) label = 'Texto';

  render() {
    let title = '';
    switch (this.colorType) {
      case 'text':
        title = 'Color de texto';
        break;
      case 'highlight':
        title = 'Color de resaltado';
        break;
      case 'table-bg':
        title = 'Color de tabla';
        break;
      case 'table-border':
        title = 'Color de borde';
        break;
      case 'cell-bg':
        title = 'Color de celda';
        break;
      default:
        title = 'Color';
    }
    return html`
      <md-filled-tonal-button 
        class="color-swatch"
        data-color-type="${this.colorType}"
        @click=${this._handleClick}
      >
        ${this.label}
        <svg slot="icon" viewBox="0 0 24 24" width="16" height="16">
          <circle cx="12" cy="12" r="10" fill="${this.backgroundColor}"/>
        </svg>
      </md-filled-tonal-button>
    `;
  }

  private _handleClick() {
    this.dispatchEvent(new CustomEvent('color-picker-click', {
      bubbles: true,
      composed: true,
      detail: { colorType: this.colorType }
    }));
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'color-picker-button': ColorPickerButton;
  }
}
